module.exports = __webpack_public_path__ + "static/media/LTC.e52f856a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/currency/LTC.svg
// module id = 1277
// module chunks = 103